// The backend bounds working-paper text with Python len(): Unicode code points, not UTF-16 units. A character outside
// the Basic Multilingual Plane (an emoji, some CJK) is one code point but two JavaScript string units, so the editor
// counts with Array.from, never String.length, to agree with what the server will accept.
export const TEXT_LIMIT = 12000;
export const textLength = (value) => Array.from(String(value ?? "")).length;
export const overLimit = (value) => textLength(value) > TEXT_LIMIT;
export const formatCount = (n) => n.toLocaleString("id-ID");
